"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var meetings_api_1 = require("../../api/meetings-api");
var bem_vindo_1 = require("./queue-cards/bem-vindo");
var na_fila_1 = require("./queue-cards/na-fila");
var atendimento_iniciado_1 = require("./queue-cards/atendimento-iniciado");
var atendimento_encerrado_1 = require("./queue-cards/atendimento-encerrado");
var atendimento_inativo_1 = require("./queue-cards/atendimento-inativo");
var atendimento_agendado_1 = require("./queue-cards/atendimento-agendado");
var atendimento_cancelado_1 = require("./queue-cards/atendimento-cancelado");
var redirect_urls_1 = require("../../constants/redirect-urls");
var status_queue_1 = require("../../constants/status-queue");
var sound_beep_1 = require("../../constants/sound-beep");
var react_i18next_1 = require("react-i18next");
require("./meeting-queue.scss");
// @ts-ignore
var react_smartbanner_1 = require("react-smartbanner");
require("react-smartbanner/dist/main.css");
var MeetingQueue = /** @class */ (function (_super) {
    __extends(MeetingQueue, _super);
    function MeetingQueue(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.queueId = null;
        _this.assuntoParam = null;
        _this.audio = null;
        _this.audioElement = null;
        /**
        * Used to initialize this component.
        */
        _this.componentDidMount = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                setTimeout(function () { return _this.setState({ botWriting: false }); }, 2500);
                this.getAppConfig();
                this.getAppSettings();
                this.getMeetingData();
                this.getMeetingQueueData();
                return [2 /*return*/];
            });
        }); };
        /**
         * Get App Configs
         * */
        _this.getAppConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppConfig()];
                    case 1:
                        response = _d.sent();
                        if (response.status === 200 && response.data) {
                            if (((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.queueRingSound) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == "queuesoundtelephone") {
                                this.audio = sound_beep_1.default.queueSoundTelephone;
                            }
                            else {
                                this.audio = sound_beep_1.default.queueSoundDefault;
                            }
                            this.setState({
                                appConfigs: response.data,
                                ratingQuestions: ((_c = response.data) === null || _c === void 0 ? void 0 : _c.ratingQuestions) ? JSON.parse(response.data.ratingQuestions) : null
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get App Settings
         * */
        _this.getAppSettings = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getAppSettings()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                appSettings: response.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
        * Get meeting data.
        */
        _this.getMeetingData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, matchAssunto;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getMeetingData(this.state.ancora)];
                    case 1:
                        response = _b.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                meetingData: response.data,
                            });
                            matchAssunto = (_a = response.data.assuntos) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return _this.assuntoParam.toLowerCase() === v.toLowerCase(); });
                            if (matchAssunto === null || matchAssunto === void 0 ? void 0 : matchAssunto.length) {
                                this.setState({
                                    assuntoSelected: matchAssunto,
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
        * Get meeting queue data.
        */
        _this.getMeetingQueueData = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, meetings_api_1.getMeetingQueueData(this.state.ancora, this.queueId)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                meetingQueueData: response.data,
                            });
                            if (this.state.assuntoSelected) {
                                meetings_api_1.updateAssuntoQueue(response.data.id, this.state.assuntoSelected);
                            }
                            if (response.data.status == status_queue_1.default.atendimentoAgendado) {
                                this.setState({
                                    scheduled: true,
                                });
                            }
                            if (response.data.status == status_queue_1.default.naFila || response.data.scheduleDay) {
                                this.keepAlive();
                                this.updateLastSeen();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
        * Keep alive queues.
        */
        _this.keepAlive = function () {
            var keepAlive = setInterval(function () {
                meetings_api_1.getMeetingQueueData(_this.state.ancora, _this.state.meetingQueueData.id).then(function (result) {
                    _this.setState({
                        meetingQueueData: __assign(__assign({}, _this.state.meetingQueueData), { queues: result.data.queues, queuePosition: result.data.queuePosition, status: result.data.status, meetingUrl: result.data.meetingUrl, assuntoSelected: result.data.assuntos })
                    });
                    if (result.data.status == status_queue_1.default.atendimentoIniciado) {
                        _this.alertBeep(true);
                        clearInterval(_this.state.lastSeenInterval);
                    }
                    if (result.data.status == status_queue_1.default.emAtendimento) {
                        _this.alertBeep(false);
                        _this.setState({ emAtendimento: true });
                        clearInterval(_this.state.lastSeenInterval);
                    }
                    if (result.data.status == status_queue_1.default.atendimentoEncerrado ||
                        result.data.status == status_queue_1.default.atendimentoInativo ||
                        _this.state.inativo) {
                        clearInterval(_this.state.keepAliveInterval);
                        clearInterval(_this.state.lastSeenInterval);
                    }
                });
            }, 20000);
            _this.setState({
                keepAliveInterval: keepAlive,
            });
        };
        /**
        * Update user last seen.
        */
        _this.updateLastSeen = function () {
            var lastSeen = setInterval(function () {
                meetings_api_1.updateLastSeen(_this.state.meetingQueueData.id);
            }, 20000);
            _this.setState({
                lastSeenInterval: lastSeen,
            });
        };
        /**
        * Update user last seen.
        */
        _this.startCall = function () {
            _this.alertBeep(false);
            _this.setState({
                emAtendimento: true,
            });
            var meetingUrl = _this.state.meetingQueueData.meetingUrl;
            if (!_this.state.emAtendimento) {
                meetings_api_1.startCall(_this.state.meetingQueueData.id).then(function (response) {
                    if (_this.state.appConfigs.useTeamsAppForJoin) {
                        meetingUrl = meetingUrl.replace(redirect_urls_1.default.browserForJoin, redirect_urls_1.default.teamsAppForJoin);
                        window.open(meetingUrl);
                    }
                    else {
                        window.open(meetingUrl);
                    }
                });
            }
            else {
                if (_this.state.appConfigs.useTeamsAppForJoin) {
                    meetingUrl = meetingUrl.replace(redirect_urls_1.default.browserForJoin, redirect_urls_1.default.teamsAppForJoin);
                    window.open(meetingUrl);
                }
                else {
                    window.open(meetingUrl);
                }
            }
        };
        /**
        * Queue wait time.
        */
        _this.timerTimeout = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.state.emAtendimento) {
                    meetings_api_1.inactivateQueue(this.state.meetingQueueData.id).then(function (response) {
                        _this.setState({ inativo: true });
                        _this.alertBeep(false);
                        clearInterval(_this.state.keepAliveInterval);
                        clearInterval(_this.state.lastSeenInterval);
                    });
                }
                return [2 /*return*/];
            });
        }); };
        /**
        * Alert beep.
        */
        _this.alertBeep = function (play) {
            if (play) {
                _this.audioElement.current.currentTime = 0;
                _this.audioElement.current.muted = false;
            }
            else {
                _this.audioElement.current.muted = true;
                _this.audioElement.current.pause();
            }
        };
        /**
        * Rating.
        */
        _this.setRating = function (rate) {
            _this.setState({
                rate: rate
            });
            if (rate == 1) {
                _this.setState({ rateLabel: _this.localize("Ruim") });
            }
            else if (rate == 2) {
                _this.setState({ rateLabel: _this.localize("Regular") });
            }
            else if (rate == 3) {
                _this.setState({ rateLabel: _this.localize("Bom") });
            }
            else if (rate == 4) {
                _this.setState({ rateLabel: _this.localize("Ótimo") });
            }
            else if (rate == 5) {
                _this.setState({ rateLabel: _this.localize("Excelente") });
            }
        };
        /**
        * Send rate.
        */
        _this.sendRating = function () {
            var objRating = {
                Rate: _this.state.rate,
                Comments: _this.state.comments
            };
            meetings_api_1.rating(_this.state.meetingQueueData.id, objRating).then(function (response) {
                _this.setState({ ratingSent: true });
            });
        };
        /**
        * Send custom rating.
        */
        _this.sendCustomRating = function () {
            meetings_api_1.rating(_this.state.meetingQueueData.id, JSON.stringify(_this.state.ratingQuestions)).then(function (response) {
                _this.setState({ ratingSent: true });
            });
        };
        /**
         * Parse week days with locale
         * */
        _this.daysOfWeekLocale = function (day) {
            if (day)
                return day
                    .replace(/segunda-feira/, _this.localize('SegundaFeira'))
                    .replace(/terça-feira/, _this.localize('TercaFeira'))
                    .replace(/quarta-feira/, _this.localize('QuartaFeira'))
                    .replace(/quinta-feira/, _this.localize('QuintaFeira'))
                    .replace(/sexta-feira/, _this.localize('SextaFeira'))
                    .replace(/sabado/, _this.localize('Sabado'))
                    .replace(/domingo/, _this.localize('Domingo'));
        };
        /**
        * Render header.
        */
        _this.renderHeader = function () {
            return (_this.state.appConfigs ?
                React.createElement(react_northstar_1.Flex, null,
                    React.createElement("audio", { muted: true, autoPlay: true, loop: true, id: "alertBeep", ref: _this.audioElement, hidden: true, controls: true },
                        React.createElement("source", { src: _this.audio, type: "audio/wav" })),
                    React.createElement(react_northstar_1.Flex.Item, null,
                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", vAlign: "center" },
                            React.createElement(react_northstar_1.Image, { src: "/images/logo.png" }),
                            React.createElement(react_northstar_1.Text, { weight: "semibold", content: _this.localize("BalcaoVirtual").toUpperCase(), size: "medium" }))),
                    React.createElement(react_northstar_1.Flex.Item, { grow: true },
                        React.createElement(react_northstar_1.Flex, { hAlign: "center", vAlign: "center" },
                            React.createElement(react_northstar_1.Label, { className: "headerLabel", content: _this.state.appConfigs.tribunal }))),
                    React.createElement(react_northstar_1.Flex.Item, null,
                        React.createElement(react_northstar_1.Flex, { gap: "gap.smaller", vAlign: "center", className: "sobre" },
                            React.createElement(react_icons_northstar_1.InfoIcon, { outline: true }),
                            React.createElement(react_northstar_1.Text, { weight: "light", content: _this.localize("Sobre"), size: "small" }))))
                :
                    React.createElement(React.Fragment, null));
        };
        /**
        * Render Assuntos.
        */
        _this.renderAssuntos = function (item, index) {
            return (React.createElement(react_northstar_1.Button, { key: index, content: item, primary: true, onClick: function () {
                    meetings_api_1.updateAssuntoQueue(_this.state.meetingQueueData.id, item).then(function (response) {
                        _this.setState({
                            assuntoSelected: item
                        });
                    });
                } }));
        };
        /**
        * Rating question changed.
        */
        _this.onQuestionChanged = function (event) {
            var indexSession = event.currentTarget.className.split('-')[0];
            var questionId = event.currentTarget.className.split('-')[1];
            var indexQuestion = _this.state.ratingQuestions.data.sessions[indexSession].questions.findIndex(function (obj) { return obj.id === questionId; });
            _this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedValue = event.currentTarget.id;
            _this.state.ratingQuestions.data.sessions[indexSession].questions[indexQuestion].selectedText = event.currentTarget.value;
            _this.setState({
                ratingQuestions: _this.state.ratingQuestions
            });
        };
        _this.onCommentChange = function (event) {
            _this.setState({
                comments: event.target.value,
            });
        };
        /**
        * Render body.
        */
        _this.renderWelcomeCard = function () {
            return (React.createElement(React.Fragment, null,
                (_this.state.meetingQueueData.status != status_queue_1.default.atendimentoEncerrado &&
                    !_this.state.inativo)
                    &&
                        React.createElement(bem_vindo_1.default, { botWriting: _this.state.botWriting, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, meetingData: _this.state.meetingData, daysOfWeekLocale: _this.daysOfWeekLocale }),
                !_this.state.botWriting &&
                    _this.renderCards()));
        };
        /**
         * Render queue cards.
         * */
        _this.renderCards = function () {
            return (React.createElement(React.Fragment, null,
                (_this.state.meetingQueueData.queuePosition > 0 &&
                    !_this.state.inativo &&
                    _this.state.meetingQueueData.status != status_queue_1.default.atendimentoAgendado) &&
                    React.createElement(na_fila_1.default, { botWriting1: _this.state.botWriting1, appConfigs: _this.state.appConfigs, meetingData: _this.state.meetingData, meetingQueueData: _this.state.meetingQueueData, assuntoSelected: _this.state.assuntoSelected, renderAssuntos: _this.renderAssuntos.bind(_this) }),
                ((_this.state.meetingQueueData.status == status_queue_1.default.atendimentoIniciado ||
                    _this.state.meetingQueueData.status == status_queue_1.default.emAtendimento)
                    && !_this.state.inativo) &&
                    React.createElement(atendimento_iniciado_1.default, { botWriting1: _this.state.botWriting1, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, meetingData: _this.state.meetingData, meetingQueueData: _this.state.meetingQueueData, startCall: _this.startCall, emAtendimento: _this.state.emAtendimento, timerTimeout: _this.timerTimeout, scheduled: _this.state.scheduled }),
                (_this.state.meetingQueueData.status == status_queue_1.default.atendimentoEncerrado) &&
                    React.createElement(atendimento_encerrado_1.default, { botWriting1: _this.state.botWriting1, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, meetingData: _this.state.meetingData, meetingQueueData: _this.state.meetingQueueData, ratingSent: _this.state.ratingSent, rate: _this.state.rate, rateLabel: _this.state.rateLabel, setRating: _this.setRating, sendRating: _this.sendRating, ratingQuestions: _this.state.ratingQuestions, onCommentChange: _this.onCommentChange, onQuestionChanged: _this.onQuestionChanged, sendCustomRating: _this.sendCustomRating }),
                (_this.state.meetingQueueData.status == status_queue_1.default.atendimentoAgendado) &&
                    React.createElement(atendimento_agendado_1.default, { botWriting: _this.state.botWriting, ancora: _this.state.ancora, meetingData: _this.state.meetingData, meetingQueueData: _this.state.meetingQueueData, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, daysOfWeekLocale: _this.daysOfWeekLocale }),
                (_this.state.meetingQueueData.status == status_queue_1.default.atendimentoInativo ||
                    _this.state.inativo) &&
                    React.createElement(atendimento_inativo_1.default, { botWriting1: _this.state.botWriting1, ancora: _this.state.ancora, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, meetingQueueData: _this.state.meetingQueueData }),
                (_this.state.meetingQueueData.status == status_queue_1.default.atendimentoCancelado) &&
                    React.createElement(atendimento_cancelado_1.default, { botWriting1: _this.state.botWriting1, ancora: _this.state.ancora, appConfigs: _this.state.appConfigs, appSettings: _this.state.appSettings, meetingQueueData: _this.state.meetingQueueData })));
        };
        Icons_1.initializeIcons();
        _this.localize = _this.props.t;
        _this.audioElement = React.createRef();
        var pathname = window.location.pathname;
        _this.state = {
            appConfigs: null,
            appSettings: null,
            ancora: pathname.split("/")[2],
            botWriting: true,
            botWriting1: false,
            step: 0,
            meetingData: [],
            meetingQueueData: [],
            queues: [],
            keepAliveInterval: null,
            lastSeenInterval: null,
            inativo: false,
            rate: 0,
            rateLabel: "",
            comments: "",
            ratingSent: false,
            emAtendimento: false,
            assuntoSelected: null,
            ratingQuestions: null,
            scheduled: false,
        };
        var search = new URLSearchParams(window.location.search);
        var dataParameter = search.get("data");
        var data = dataParameter ? window.atob(dataParameter) : "";
        var dataValue = JSON.parse(data);
        _this.queueId = (_a = dataValue['queueId']) !== null && _a !== void 0 ? _a : "";
        _this.assuntoParam = (_b = decodeURIComponent(dataValue['assunto'])) !== null && _b !== void 0 ? _b : null;
        if (_this.queueId == "") {
            window.location.pathname = "/errorpage?msg=QueueId is invalid";
        }
        return _this;
    }
    /**
     * Render this component.
     * */
    MeetingQueue.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(react_smartbanner_1.default, { button: "Instalar", position: "top", storeText: { ios: 'App Store', android: 'Google Play' }, price: { ios: 'GRÁTIS', android: 'GRÁTIS' }, title: 'Microsoft Teams' }),
            React.createElement("div", { className: "header" },
                React.createElement(react_northstar_1.Segment, { className: "headerLine", inverted: true, content: this.renderHeader() })),
            React.createElement("div", { className: "body" }, this.renderWelcomeCard())));
    };
    return MeetingQueue;
}(React.Component));
var meetingQueueWithTranslation = react_i18next_1.withTranslation()(MeetingQueue);
exports.default = meetingQueueWithTranslation;
//# sourceMappingURL=meeting-queue.js.map